import { useEffect, useState } from "react";

// Componentes
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import ButtonSpinner from "../../../../../components/Buttons/ButtonSpinner";

// Services
import { updateEventsXGroups } from "../../../../../utils/services/portalBoticario";

const TAG_OPTIONS = [
  { value: "base", label: "Base de Cadastros" },
  { value: "registered", label: "Cadastrados" },
];

export const ModalEditEventsXGroups = ({
  isOpen,
  toggle,
  jwt,
  refetch,
  itemData,
}) => {
  // state do formulário
  const [formData, setFormData] = useState({ tag: "" });

  // state de controle
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isShowSuccess, setIsShowSuccess] = useState(false);

  useEffect(() => {
    if (itemData) {
      setFormData({ tag: itemData.tag || "" });
    }
  }, [itemData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // traduz mensagem de erro da API para texto amigável
  const getApiErrorMessage = (message) => {
    const map = {
      ID_NOT_FOUND: "O vínculo que você está tentando editar não foi encontrado.",
      NOT_FOUND: "O vínculo que você está tentando editar não foi encontrado.",
    };
    return (
      map[message] ||
      message ||
      "Erro ao conectar com o servidor. Verifique sua conexão."
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.tag) {
      setErrors({ tag: "Campo obrigatório" });
      return;
    }

    setErrors({});
    setIsLoading(true);

    try {
      await updateEventsXGroups(itemData.id, { tag: formData.tag }, jwt);
      refetch();
      setIsShowSuccess(true);
    } catch (error) {
      const message = error.response?.data?.message;
      setErrors({ api: getApiErrorMessage(message) });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} centered autoFocus>
      <ModalHeader toggle={toggle}>Editar Vínculo Evento x Grupo</ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col lg={12} style={{ marginBottom: 10 }}>
              <label className="form-label">ID do Evento</label>
              <input
                className="form-control"
                type="text"
                value={itemData?.eventId || ""}
                disabled
              />
            </Col>

            <Col lg={12} style={{ marginBottom: 10 }}>
              <label className="form-label">ID do Grupo</label>
              <input
                className="form-control"
                type="text"
                value={itemData?.groupId || ""}
                disabled
              />
            </Col>

            <Col lg={12} style={{ marginBottom: 10 }}>
              <label className="form-label">Tag *</label>
              <select
                className="form-control"
                name="tag"
                value={formData.tag}
                onChange={handleChange}
              >
                <option value="">Selecione...</option>
                {TAG_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
              {errors.tag && (
                <span className="text-danger" style={{ fontSize: 12 }}>
                  {errors.tag}
                </span>
              )}
            </Col>
          </Row>

          {errors.api && (
            <Row>
              <Col lg={12} style={{ marginBottom: 10 }}>
                <span className="text-danger" style={{ fontSize: 13 }}>
                  {errors.api}
                </span>
              </Col>
            </Row>
          )}

          <Row>
            <Col
              md={12}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 10,
              }}
            >
              <Button
                color="danger"
                style={{ width: 80, marginRight: 10 }}
                onClick={toggle}
                disabled={isLoading}
              >
                Fechar
              </Button>
              <ButtonSpinner
                title="Salvar"
                type="submit"
                isLoading={isLoading}
                action="U"
              />
            </Col>
          </Row>
        </form>
      </ModalBody>

      {isShowSuccess && (
        <SweetAlert
          title="Atualizado"
          success
          onConfirm={() => {
            setIsShowSuccess(false);
            toggle();
          }}
        >
          Vínculo atualizado com sucesso!
        </SweetAlert>
      )}
    </Modal>
  );
};
